export { RateOrPackageContainer as RateOrPackageDetail } from './container';
